import './currency-7be6806c.js';
import { p as pesPathnamePageTypeToPageTypeMap } from './pes-router-store-0c1092be.js';

class PesURL extends URL {
    constructor(url, base) {
        super(url, base);
        // TODO: double check what kinds of URLs we should parse. It seems like there may be any character in a url segment.
        this.urlRegexps = {
            allProducts: /(?<countryCode>\w+)\/(?<languageCode>\w+)(?:\/v3)?\/(?<pageTypeRaw>(?:[\w-])+)\//,
            product: /(?<countryCode>\w+)\/(?<languageCode>\w+)(?:\/v3)?\/(?<pageTypeRaw>(?:[\w-])+)\/(?<pageId>[\w.-]+)(?:\/(?<pageSEOName>.+))?\//,
            rangeCategorySubcategory: /(?<countryCode>\w+)\/(?<languageCode>\w+)(?:\/v3)?\/(?<pageTypeRaw>(?:[\w-])+)\/(?<pageId>[\w.]+)(?:-(?<pageSEOName>.+))?\//,
        };
        this.getPageTypeProcessed = (pageTypeTaw) => {
            return pesPathnamePageTypeToPageTypeMap[pageTypeTaw];
        };
        this.getProcessedURLParts = () => {
            let parsed;
            // So far, we handle only the following cases:
            // - all products `/ww/en/all-product/`
            // - category `/ww/en/product-category/{category_id}/`
            // - sub-category `/ww/en/product-subcategory/{subcategory_id}/`
            // - range `/ww/en/product-range/{range_id}/`
            // - product `/ww/en/product/{product_id}/`
            //
            // There are some other types of pages that we don't handle yet:
            // - business `/ww/en/work/products/`
            // - site `/ww/en/`
            if (this.normalizedPathname.includes('all-products')) {
                parsed = this.urlRegexps.allProducts.exec(this.normalizedPathname);
            }
            else if (this.normalizedPathname.includes('product-')) {
                parsed = this.urlRegexps.rangeCategorySubcategory.exec(this.normalizedPathname);
            }
            else if (this.normalizedPathname.includes('product')) {
                parsed = this.urlRegexps.product.exec(this.normalizedPathname);
            }
            if (!parsed.groups) {
                throw new RangeError("Can't handle this URL.");
            }
            return parsed.groups;
        };
        this.getPathnameParsed = () => {
            const parts = this.getProcessedURLParts();
            const { countryCode, languageCode, pageTypeRaw, pageId, pageSEOName } = parts;
            return {
                countryCode,
                languageCode,
                pageTypeRaw,
                pageType: pageTypeRaw ? this.getPageTypeProcessed(pageTypeRaw) : undefined,
                pageId,
                pageSEOName,
            };
        };
        const pesPathnameParsed = this.getPathnameParsed();
        this.countryCode = pesPathnameParsed.countryCode;
        this.languageCode = pesPathnameParsed.languageCode;
        this.pageTypeRaw = pesPathnameParsed.pageTypeRaw;
        this.pageType = pesPathnameParsed.pageType;
        this.pageId = pesPathnameParsed.pageId;
        this.pageSEOName = pesPathnameParsed.pageSEOName;
    }
    get normalizedPathname() {
        let { pathname } = this;
        // force pathname of chinese website to have the same shape as all others locales
        if (this.origin.endsWith('.cn') || this.pathname.startsWith('/zh')) {
            pathname = `/cn${this.pathname}`;
        }
        if (!pathname.endsWith('/')) {
            pathname = `${pathname}/`;
        }
        return pathname;
    }
}
const parseCommonURLToRouterParts = (urlRaw, options) => {
    const { prefix } = options || {};
    let url = urlRaw;
    if (prefix) {
        url = url.replace(prefix, '');
    }
    let pesUrl;
    if (!url.startsWith('http')) {
        const { origin: base } = window.location;
        pesUrl = new PesURL(url, base);
    }
    else {
        pesUrl = new PesURL(url);
    }
    const { countryCode, languageCode, pageTypeRaw, pageType, pageId, pageSEOName } = pesUrl;
    return {
        countryCode,
        languageCode,
        pageTypeRaw,
        pageType,
        pageId,
        pageSEOName,
    };
};

export { parseCommonURLToRouterParts as p };
